import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSettings } from "@app/common/app-setting";
import { debug } from "util";
import { resetPassword } from "@app/models/OTPResult";

@Injectable()
export class ForgotPasswordEndpoint{
    http1 : HttpClient;
    _baseurl = `${AppSettings.API_ENDPOINT}`;
    private readonly _getOTPurl: string = 'api/AccountController/GetOTP/';
    //  private readonly _getOTPurl: string = 'api/AccountController/GetOtpForRegistration/';
    private readonly _getPasswordResetUrl: string = 'api/AccountController/VerifyOtp/';
    constructor(http: HttpClient){
        this.http1 = http;
    }
    getUrl(url: string) {
        return this._baseurl + url;
    }

    
    getOTP(reset: resetPassword) {
        //    let apiUrl = this.getUrl(this._getOTPurl),reset;
        //     return this.http1.post(apiUrl);
            return this.http1.post(this.getUrl(this._getOTPurl),reset);
        }

        resetPasssword(number:string,otp:string){
            var reset = new resetPassword();
            reset.mobileNumber =number;
            reset.otp =otp;
            return this.http1.post(this.getUrl(this._getPasswordResetUrl) ,reset , {
                headers: new HttpHeaders().set('Content-Type', 'application/json')
            });
        }
}


// WEBPACK FOOTER //
// ./src/app/services/authentication/forgotPassword-endpoint.service.ts